import './media_library.expanded_asset.less';

import React, { Fragment } from 'react';
import classNames from 'classnames';

import noop from 'lodash/noop';
import includes from 'lodash/includes';

import Presentation from 'zoomforth_presentation/presentation_root.jsx';
import VideoishPlayer from 'zoomforth_component_lib/videoish_player.jsx';
import { LoadingIcon, ErrorIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';
import FittedImgContainer from 'zoomforth_component_lib/fitted_image_container.jsx';
import IframeWithOnload from 'zoomforth_component_lib/iframe_with_onload.jsx';

import { isVideoishAssetType } from '../lib/assets.js';

const ExpandedAssetUI = ({ 
  assetType,
  createdAtFormatted, 
  description, 
  htmlPackageEntrypointUrl,
  isShowingInfoPanel, 
  isLoading,
  pdfUrl,
  lastModifiedAtFormatted, 
  name, 
  otherDisplayImageUrl,
  photoUrl,
  presentationDownloadLink,
  presentationSlides,
  videoishSources,
  videoishSubtitles,
  videoishPosterUrl,
  uploadPerson, 
  onClose,
  onPdfLoad,
  onHtmlPackageLoad,
  onRefAttach
})=> {

  const loadingIcon = <LoadingIcon spin={true} style={{position:'absolute', color:'white', left:'50%', top:'50%'}}/>;
  const loadingFailedIcon = <ErrorIcon style={{position:'absolute', color:'red', left:'50%', top:'50%'}}/>;

  return (
    <div className="expanded-asset" ref={onRefAttach}>
      <div className="background-layer" onClick={onClose}></div>
      <div className="close-modal-button" onClick={onClose}>
        <img src="https://d3jozdooylvm2p.cloudfront.net/images/icons/x_icon.png" className="close-overlay-icon"/>
      </div>
      <div className="asset-display-box">
        <FittedImgContainer className={classNames(
          'asset-wrapper',
          {
            'has-video': isVideoishAssetType(assetType),
            'has-pdf': assetType === 'pdf',
            'has-presentation': assetType === 'ppt',
            'has-html-package': assetType === 'html_package'
          })}
          src={
            otherDisplayImageUrl || photoUrl
          }
          loadingIcon={loadingIcon}
          loadingFailedIcon={loadingFailedIcon}
          onClick={(e)=> {
            if (includes(e.target.classList, 'asset-wrapper')) {
              onClose();
            }
          }}
        >

          { isLoading && loadingIcon }

          {

            assetType === 'pdf' ?

              <IframeWithOnload
                className="pdf-iframe"
                title="PDF Viewer"
                frameBorder="0" 
                src={pdfUrl}
                onLoad={onPdfLoad}
              />

            : assetType === 'html_package' ?

              <IframeWithOnload 
                className="html-package-iframe"
                title="HTML Package Viewer"
                frameBorder="0" 
                src={htmlPackageEntrypointUrl}
                onLoad={onHtmlPackageLoad}
              />

            : isVideoishAssetType(assetType) ? // video or youtube

              <VideoishPlayer
                sources={videoishSources}
                subtitleTrack={videoishSubtitles}
                posterImageUrl={videoishPosterUrl}
                autoplay
              />

            : assetType === 'ppt' ?

              <Presentation
                slides={presentationSlides}
                downloadLink={presentationDownloadLink}
                displayFilename={name}
                canDownloadAsset={false}
                onDownloadClick={noop}
                onPresentationLoad={noop}
              />

            :
              null
          }
        </FittedImgContainer>
      </div>
      { isShowingInfoPanel &&
        <div className="read-only-info-panel">
          <div className="read-only-asset-name"> 
            {name}
          </div>
          <div className="read-only-details">
            { description &&
              <div className="read-only-description">
                <span className="info-title">Description</span> <Fragment dangerouslySetInnerHTML={{__html: description}} />
              </div>
            }
            <div className="asset-date-added">
              <span className="info-title">Date added</span> {createdAtFormatted}
            </div>
            <div className="asset-date-modified">
              <span className="info-title">Last modified</span> {lastModifiedAtFormatted}
            </div>
            { uploadPerson &&
              <div className="asset-uploaded-by">
                <span className="info-title">Uploaded by</span> 
                <div className="uploaded-by-content">
                  {uploadPerson}
                </div>
              </div>
            }
          </div>
        </div>  
      }
    </div>
  );
};

export default ExpandedAssetUI;


  